module.exports = __webpack_public_path__ + "files/bd227e41f9f329ea1e6a30a867f119bf.png";